import React from 'react';
import { Form, Formik } from 'formik';
import { Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Yup from '../../../utils/yup';
import { WmsType } from '../../../config/wms/wmsType';
import { ButtonUI } from '../../Interface';
import wmsBaseService from '../../../service/wms/wmsBase.service';
import WarehouseField from '../Components/WarehouseField';

const NewInventoryTransfer = ({ autocompleteData, autocompleteOptions }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const ui = theme.palette.ui;
  const defaultHead = {
    whsCode: '',
  };

  const validationSchema = Yup.object().shape({
    whsCode: Yup.string().required(),
  });

  const handleSubmit = async (values) => {
    const response = await wmsBaseService.createData({ ...values, wmsType: WmsType.InventoryTransfer });

    navigate(`../inventoryTransferDoc/${response.id}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 4, px: 2, width: '100%' }}>
      <Formik
        initialValues={defaultHead}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, setFieldValue, isSubmitting }) => (
          <Form>
            <WarehouseField
              value={values.whsCode}
              onChange={(nextValue) => setFieldValue('whsCode', nextValue)}
              warehouseData={autocompleteData?.warehouse}
              warehouseOptions={autocompleteOptions?.warehouse}
              helperText={errors.whsCode}
            />

            <Box
              sx={{
                display: 'flex',
                gap: 3,
                justifyContent: 'center',
                py: 1,
              }}
            >
              <ButtonUI
                text="Indítás"
                className="flex gap-2 items-center"
                style={{ background: ui.addButton }}
                type={'submit'}
                disabled={isSubmitting}
              >
                Rögzítés
              </ButtonUI>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default NewInventoryTransfer;
